export default __webpack_public_path__ + "static/media/MultiLoja.2b81e668.svg";